var _path, _path2, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVerifiedBadge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91.8312 6.33228C96.6393 2.60511 103.361 2.60511 108.169 6.33228L125.008 19.3856C127.206 21.0895 129.882 22.0634 132.661 22.171L153.951 22.9956C160.03 23.231 165.179 27.5514 166.466 33.4972L170.975 54.3206C171.564 57.0387 172.987 59.5047 175.047 61.3734L190.826 75.6901C195.332 79.778 196.499 86.3971 193.663 91.7795L183.732 110.629C182.436 113.09 181.941 115.894 182.318 118.65L185.203 139.759C186.027 145.787 182.666 151.608 177.034 153.908L157.31 161.965C154.736 163.016 152.554 164.847 151.072 167.2L139.712 185.225C136.469 190.372 130.153 192.671 124.36 190.813L104.072 184.306C101.424 183.457 98.5762 183.457 95.928 184.306L75.6399 190.813C69.847 192.671 63.531 190.372 60.2876 185.225L48.9285 167.2C47.4458 164.847 45.2645 163.016 42.6899 161.965L22.9658 153.908C17.3339 151.608 13.9732 145.787 14.797 139.759L17.6819 118.65C18.0585 115.894 17.564 113.09 16.2677 110.629L6.33681 91.7795C3.50119 86.3972 4.66833 79.778 9.1738 75.6901L24.9529 61.3734C27.0126 59.5047 28.4363 57.0387 29.0249 54.3206L33.5339 33.4972C34.8214 27.5514 39.9702 23.231 46.0492 22.9956L67.3393 22.171C70.1183 22.0634 72.794 21.0895 74.9921 19.3856L91.8312 6.33228Z",
    fill: "url(#paint0_radial_22220_1719)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5117 7.20996C96.7816 3.90012 102.698 3.79716 107.07 6.90039L107.488 7.20996L124.327 20.2637C126.56 21.9942 129.247 23.0293 132.055 23.248L132.618 23.2812L153.908 24.1055C159.306 24.3147 163.904 28.0382 165.259 33.2256L165.38 33.7324L169.89 54.5557C170.487 57.3164 171.88 59.8371 173.891 61.8096L174.301 62.1963L190.079 76.5127C194.08 80.1428 195.21 85.9509 192.913 90.7959L192.68 91.2617L182.749 110.111C181.432 112.61 180.879 115.437 181.151 118.24L181.217 118.8L184.103 139.91C184.834 145.263 181.965 150.438 177.092 152.673L176.614 152.88L156.89 160.937C154.275 162.005 152.035 163.814 150.441 166.136L150.132 166.607L138.772 184.633C135.892 189.203 130.368 191.324 125.198 189.903L124.699 189.755L104.411 183.248C101.722 182.385 98.8422 182.331 96.1289 183.086L95.5889 183.248L75.3008 189.755C70.1566 191.405 64.5623 189.479 61.5146 185.067L61.2275 184.633L49.8682 166.607C48.3623 164.218 46.1917 162.325 43.6279 161.159L43.1104 160.937L23.3857 152.88C18.3847 150.837 15.3372 145.766 15.8379 140.428L15.8975 139.91L18.7832 118.8C19.1656 116.001 18.7184 113.156 17.5039 110.615L17.251 110.111L7.32031 91.2617C4.80226 86.4822 5.72705 80.6384 9.54199 76.8711L9.9209 76.5127L25.6992 62.1963C27.7911 60.2983 29.2775 57.8317 29.9805 55.1045L30.1104 54.5557L34.6201 33.7324C35.7634 28.4525 40.2282 24.5704 45.5723 24.1367L46.0918 24.1055L67.3818 23.2812C70.2044 23.1719 72.9291 22.238 75.2207 20.6006L75.6729 20.2637L92.5117 7.20996Z",
    stroke: "white",
    strokeOpacity: 0.4,
    strokeWidth: 2.22222
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di_22220_1719)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.521 73.0726C124.028 73.0726 128.681 74.2121 132.48 76.4912C136.468 78.7702 139.412 81.7139 141.311 85.3223C143.4 88.7409 144.445 92.6342 144.445 97.0023C144.445 102.51 142.735 107.258 139.317 111.246C136.088 115.044 131.72 116.944 126.212 116.944C121.464 116.944 117.381 115.519 113.963 112.671C110.734 109.822 109.12 105.928 109.12 100.991C109.12 96.8124 110.164 93.2989 112.253 90.4501C114.532 87.4114 117.096 85.0375 119.945 83.3282C118.046 81.8089 115.767 81.1441 113.108 81.3341C107.98 81.524 103.232 83.2332 98.8642 86.4619C94.4961 89.5005 90.7927 93.4888 87.754 98.4267C84.7154 103.175 82.3414 108.302 80.6321 113.81C78.9229 119.318 78.0682 122.194 78.0682 126.942C78.5862 126.942 73.1994 126.942 73.1994 126.942V108.112C73.1994 102.878 72.6539 100.373 70.4512 97.143C67.6025 92.9648 63.5322 92.9033 55.5557 92.9033V86.9209C57.075 87.0633 61.2904 87.1228 64.1578 87.1228C71.1639 87.1228 72.76 87.0018 78.0682 85.1156V106.688C80.3472 101.18 83.3859 95.8628 87.1843 90.735C90.9827 85.6072 95.5407 81.429 100.858 78.2004C106.176 74.7819 112.064 73.0726 118.521 73.0726Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_22220_1719",
    x: 11.1112,
    y: 50.8504,
    width: 177.778,
    height: 142.759,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 22.2222
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 22.2222
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.947585 0 0 0 0 0.522687 0 0 0 0 0.265512 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_22220_1719"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_22220_1719",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.11111
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_22220_1719"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_22220_1719",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25 45) rotate(31.4296) scale(316.425 367.203)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF8355"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.384399,
    stopColor: "#CEAF85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B876D"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifiedBadge);
export default __webpack_public_path__ + "static/media/verified-badge.f7692524b5c308cb7d7df6ac9dc700d2.svg";
export { ForwardRef as ReactComponent };